import { COMMISSION_SOURCE_TABS } from "./commissionsConstants";

const formatCurrency = (value) =>
  `$${Number(value ?? 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatPercent = (value) =>
  `${Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;

function getTabMetrics(source, {
  fcMotivate,
  fcMotivatePercentage,
  emailManager,
  saleTeam,
  aceProgress,
}) {
  let percentage = null;
  let totalUnpaid = 0;

  switch (source) {
    case "fc_motivate":
      percentage = fcMotivate?.percentage ?? fcMotivatePercentage ?? null;
      totalUnpaid = fcMotivate?.totalUnpaid ?? 0;
      break;
    case "email_manager":
      percentage = emailManager?.percentage ?? null;
      totalUnpaid = emailManager?.totalUnpaid ?? 0;
      break;
    case "ace_performance":
      percentage = aceProgress?.percentage ?? null;
      totalUnpaid = aceProgress?.totalUnpaid ?? 0;
      break;
    case "sales_team":
      percentage = saleTeam?.percentage ?? null;
      totalUnpaid = saleTeam?.totalUnpaid ?? 0;
      break;
    default:
      break;
  }

  return {
    percentage: percentage == null ? "-" : formatPercent(percentage),
    owed: formatCurrency(totalUnpaid),
  };
}

export default function CommissionsSourceTabs({
  activeSource,
  onChange,
  fcMotivate,
  fcMotivatePercentage,
  emailManager,
  saleTeam,
  aceProgress,
}) {
  const summaryData = {
    fcMotivate,
    fcMotivatePercentage,
    emailManager,
    saleTeam,
    aceProgress,
  };

  return (
    <div className="flex flex-wrap gap-2 px-4 pt-4">
      {COMMISSION_SOURCE_TABS.map((tab) => {
        const isActive = activeSource === tab.value;
        const { percentage, owed } = getTabMetrics(tab.value, summaryData);

        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => onChange(tab.value)}
            className={`px-4 py-2 rounded-lg text-sm font-medium border transition-colors text-left ${
              isActive
                ? "bg-primary-600 text-white border-primary-600"
                : "bg-white text-gray-600 border-gray-300 hover:border-primary-300"
            }`}
          >
            <span className="block">{tab.label}</span>
            <span
              className={`block text-xs mt-0.5 font-normal ${
                isActive ? "text-white/80" : "text-gray-500"
              }`}
            >
              {percentage} · {owed}
            </span>
          </button>
        );
      })}
    </div>
  );
}
